import { createTheme } from '@material-ui/core/styles';

export const theme = createTheme({
  typography: {
    useNextVariants: true,
    suppressDeprecationWarnings: true,
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#db3131',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
});
export const formLabelsTheme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#EB9937',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
  },
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: '#db3131',
        '&$error': {
          color: '#db3131',
        },
      },
    },
  },
});

export const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      overflow: 'auto',
    },
  },
  input: {
    height: 40,
    [theme.breakpoints.up('300')]: {
      width: 130,
    },
    [theme.breakpoints.up('576')]: {
      width: 200,
    },
    [theme.breakpoints.up('768')]: {
      width: 130,
    },
    [theme.breakpoints.up('1024')]: {
      width: 160,
    },
    color: '#76787A',
    fontSize: '14px',
  },
  input_priority: {
    width: 80,
  },
  input_comments: {
    width: 490,
    height: 'unset',
    [theme.breakpoints.down('576')]: {
      width: 250,
    },
  },
  selectRoot: {
    height: 40,
    display: 'table',
  },
  select: {
    height: 40,
    paddingTop: '25.5px',
    paddingBottom: 0,
    display: 'table-cell',
    verticalAlign: 'middle',
    '&:focus': {
      backgroundColor: 'transparent !important',
    },
  },
  labelAsterisk: {
    color: 'red',
  },
});

